import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-met-inhouding-dividendbelasting',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-met-inhouding-dividendbelasting.component.html',
  styleUrl: './tekst-met-inhouding-dividendbelasting.component.scss',
})
export class TekstMetInhoudingDividendbelastingComponent {}
